import { search } from 'jmespath';

import { IConfigurationRule } from './IConfigurationRule';

const EXPRESSION_SEPARATOR = ' ';
const OPEN_GROUP = '(';
const CLOSE_GROUP = ')';
const NEGATE_KEY = '!';
const AND_KEY = 'and';
const OR_KEY = 'or';

export const translateConditionToJmesPath = (condition: string): string => {
  const parts = condition.split(EXPRESSION_SEPARATOR);
  const newParts = parts.map(part => {
    if (part.toLowerCase() === OR_KEY) {
      return '||';
    }
    if (part.toLowerCase() === AND_KEY) {
      return '&&';
    }
    if (part === OPEN_GROUP || part === CLOSE_GROUP) {
      return part;
    }
    if (part.length > 0) {
      if (part[0] === NEGATE_KEY) {
        return `${NEGATE_KEY}${translateConditionToJmesPath(part.substring(1))}`;
      }
      return `contains(@, '${part}')`;
    }
    return '';
  });
  return newParts.join(EXPRESSION_SEPARATOR);
}

export const translateRuleConditionToJmespath = (rule: IConfigurationRule): IConfigurationRule => {
  if (!rule.condition) {
    return rule;
  }

  const translatedCondition = translateConditionToJmesPath(rule.condition);
  return {
    ...rule,
    condition: translatedCondition,
  };
}

export const isValidRules = (features: string[], rules: IConfigurationRule[]) => {
  for (let x = 0; x < rules.length; x++) {
    if (!isValidRule(features, rules[x])) {
      return false;
    }
  }
  return true;
}

export const isValidRule = (features: string[], rule: IConfigurationRule) => {
  if (rule.condition && features.indexOf(rule.packCode) > -1) {
    const result = search({ features }, `features[] | ${rule.condition}`);
    return !!result;
  }
  return true;
}

/**
 * Given the set of existing features, check if new feature is valid
 * @param existingFeatures
 * @param featureIndex index of where the feature is replacing, -1 if not feature set yet for that packset
 * @param newFeature
 * @param rules
 */
export const isNewOptionValid = (existingFeatures: string[], featureIndex: number, newFeature: string, rules: IConfigurationRule[]) => {
  const features = [...existingFeatures];
  if (featureIndex >= 0 && featureIndex < existingFeatures.length) {
    features[featureIndex] = newFeature;
  } else {
    features.push(newFeature);
  }

  return isValidRules(features, rules);
}
